<template>
  <div class="files-content">
    <div class="contents">
      <div class="body">
        <div class="-head">
          <div class="head-left">
            <div class="-avatar">
              <img
                class="user-avatar"
                :src="
                  data && data.user && data.user.head_pic
                    ? data.user.head_pic
                    : '/static/images/avatar.svg'
                "
              />
              <img
                v-if="
                  data.highest_vip_level != null &&
                  data.highest_vip_level.package_id == 2
                "
                class="ic-pro"
                src="/static/images/ic_svip.svg"
              />
              <img
                v-else-if="
                  data.highest_vip_level != null &&
                  data.highest_vip_level.package_id == 1
                "
                class="ic-pro"
                src="/static/images/ic_vip.svg"
              />
            </div>
            <div style="min-width: 200px">
              <p class="title _text-overflow">
                {{
                  data && data.user && data.user.usernick
                    ? data.user.usernick
                    : "未找到该用户"
                }}
                {{ !error ? "的分享" : "的分享" }}
              </p>
              <div class="meta">
                <span>
                  {{
                    info && info.expired_day > 0
                      ? info.expired_day + "天后过期"
                      : "已过期"
                  }}</span
                >
                <span
                  class="report"
                  @click="fileReport"
                  v-if="info && info.expired_day > 0 && !error"
                  >举报</span
                >
              </div>
            </div>
          </div>
          <el-popover
            placement="bottom"
            popper-class="mon-popper"
            width="160"
            trigger="click"
            v-if="isMobile && info && info.expired_day > 0"
          >
            <div style="width: 100%; text-align: center">
              <img :src="qrImg" />
              <p>{{ codeMsg }}</p>
            </div>
            <img
              slot="reference"
              class="qrcode"
              src="/static/images/qrcode.svg"
            />
          </el-popover>
          <!-- 电脑模式 -->
          <div
            v-if="!isMobile && info && info.expired_day > 0"
            style="display: flex"
          >
            <div class="computer-button" @click="downFileApi">
              <img
                src="/static/images/ic_button-download.svg"
                class="button-icon"
                alt=""
              />
            </div>
            <!-- <el-button
              type="primary"
              icon="el-icon-download"
              round
              @click="downFileApi"
              >下载</el-button
            > -->
            <el-popover
              popper-class="mon-popper"
              placement="bottom"
              width="160"
              trigger="click"
            >
              <div style="width: 100%; text-align: center">
                <img :src="qrImg" />
                <p>{{ codeMsg }}</p>
              </div>
              <div slot="reference" class="computer-button">
                <img
                  src="/static/images/ic_button-qr.svg"
                  class="button-icon"
                  alt=""
                />
              </div>
            </el-popover>
          </div>
        </div>
        <!-- 文件过期 -->
        <div v-if="info.expired_day <= 0">
          <error
            :errorContent="'哎呀！分享的文件已经过期了'"
            :errorType="'delete'"
          ></error>
        </div>
        <div v-if="error">
          <error
            :errorContent="errorMessage"
            :errorType="errorType || 'delete'"
          ></error>
        </div>
        <!-- 文件卡片 -->
        <div class="main-info" v-if="info.expired_day > 0 && !error">
          <template>
            <div class="file-mode-center">
              <!-- 非预览模式图标 -->
              <el-image
                v-if="!error && !data.info.isImage"
                @click="previewFile"
                class="file-icon"
                :src="data.info.icon"
                fit="cover"
              ></el-image>
              <!-- 预览模式图片 -->
              <el-image
                v-if="!error && data.info.isImage"
                class="file-wallpaper"
                :style="{ width: imageWitdh && isMobile ? '50%' : '' }"
                :src="data.info.wallpaper_h5"
                @load="onImageLoad"
                :preview-src-list="[data.info.wallpaper_web]"
                fit="cover"
              ></el-image>
              <template v-if="!error">
                <p class="file-name">
                  {{ data.info.cloudfile != null ? data.info.file_name : "" }}
                </p>
                <span class="file-size">
                  {{ data.info.cloudfile != null ? data.info.Length : "" }}
                </span>
              </template>
            </div>
          </template>
          <div class="tips" v-if="!error">获得链接的好友可查看</div>
          <div class="tips" v-if="error">
            {{ errorMessage || "文件已过期" }}
          </div>
        </div>
      </div>
      <!--  -->
      <div style="height: 200px"></div>
    </div>

    <!-- 手机端下载按钮 -->
    <div class="buttons">
      <div
        class="new-button"
        v-if="info && info.expired_day > 0 && !error && isMobile"
        @click="downFileApi"
      >
        下载
      </div>
    </div>
    <!-- 举报 -->
    <el-dialog
      title="举报原因"
      :visible.sync="showBanType"
      width="320px"
      center
    >
      <span>
        <div v-for="item in banTypeList" :key="item.id">
          <el-radio
            class="ban-radio"
            v-model="selectBan"
            :label="item.ban_type"
            >{{ item.type_name }}</el-radio
          >
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="confirm-btn"
          type="primary"
          round
          :loading="btnLoad"
          @click="confirmReport"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  shareFileInfo,
  getBanType,
  submitBan,
  getCdnSignature,
} from "@/api/sharefiles";
import * as util from "../../utils/util";
import * as QR from "../../utils/weppQrcode";
import error from "@/components/errorPage";

export default {
  name: "shareFilesDetail2",
  components: {
    error,
  },
  data() {
    return {
      isMobile: false,
      id: "",
      data: {},
      info: {},
      user: {},
      error: false,
      errorMessage: "",
      exeButton: false,
      isBindComputer: false,
      showBindComputerTips: false,
      showCover: false,
      qrImg: "",
      codeMsg: "扫码在手机上下载",
      banTypeList: [],
      selectBan: "",
      showBanType: false,
      btnLoad: false,
      errorType: "",
      imageWitdh: false,
    };
  },
  mounted() {
    this.checkDeviceType();
    // 注册 resize 事件监听器，传入防抖函数作为回调
    window.addEventListener("resize", this.debounce(this.checkDeviceType, 200));
  },
  created() {
    var url = window.location.href;
    // 使用正则表达式截取目标段落
    var extractedPart = url.match(/\/s\/(.+)/)[1].split('_')[0];
    // 提取截取的部分
    this.id = extractedPart ? extractedPart : this.$route.query.encryption_key;
    if (this.IEVersion() != -1) {
      this.error = true;
      this.errorType = "ie";
      this.errorMessage =
        "当前页面不支持IE11及以下浏览器访问，建议使用Chrome、Edge、Firefox等浏览器访问。";
      return;
    }
    this.getFiles();
    // let ua = navigator.userAgent
    // this.isWeixin = !!/MicroMessenger/i.test(ua)
    if (this.isWeixin()) {
      this.codeMsg = "长按识别二维码";
    } else {
      this.codeMsg = "扫码在手机上下载";
    }
    // setCookie('token', 'abc123qwer')
    //console.log(this.IEVersion());
  },
  methods: {
    checkDeviceType() {
      const width = window.innerWidth;
      this.isMobile = width <= 768;
      //console.log("isMobile", this.isMobile);
    },
    debounce(func, delay) {
      let timerId;
      return function () {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
          func.apply(this, arguments);
        }, delay);
      };
    },
    // 举报
    fileReport() {
      // console.log(this.id)
      getBanType().then((res) => {
        if (res.code == 100) {
          this.banTypeList = res.data;
          this.showBanType = true;
        }
      });
    },
    confirmReport() {
      // console.log(this.selectBan)
      this.btnLoad = true;
      let data = {
        encryption_key: this.id,
        ban_type: this.selectBan,
      };
      submitBan(data).then((res) => {
        this.btnLoad = false;
        if (res.code == 100) {
          this.showBanType = false;
          this.$message({
            message: "举报成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    onImageLoad(e) {
      console.log("dada", e.path[0].naturalWidth);
      this.imageWitdh = e.path[0].naturalWidth > 64; //原图大于64px在手机端的显示比例为容器的50%
    },
    getFiles() {
      // var self = this;
      const data_opt = {
        encryption_key: this.id,
      };
      shareFileInfo(data_opt).then((data) => {
        if (data.code === 100 && data.data) {
          var item = data.data;
          item.info.type = util.fileType(
            item.info.file_name.substr(item.info.file_name.lastIndexOf("."))
          );
          item.info.icon = `https://images.hipcapi.com/images/file_icon/new/${util.fileType(
            item.info.file_name.substr(item.info.file_name.lastIndexOf("."))
          )}.svg`;
          item.info.wallpaper_h5 = item.info.cloudfile.callback320 ? `https://pic-icon.hipcapi.com${item.info.cloudfile.callback320}` : ``
          item.info.wallpaper_web = `https://cloud.hipcapi.com/${item.info.cloudfile.file_key}`
          item.info.isImage = util.fileTypeImage(
            item.info.file_name.substr(item.info.file_name.lastIndexOf("."))
          );
          item.info.Size = item.info.cloudfile.filesize;
          item.info.Length = util.fs(item.info.cloudfile.filesize);
          item.info.Extension = item.info.file_name.substr(
            item.info.file_name.lastIndexOf(".")
          );

          this.data = item;
          this.info = item.info;
          this.user = item.user;
          document.title = "HiPC分享";
          this.error = false;
          this.qrImg = QR.drawImg(window.location.href, {
            typeNumber: 4,
            errorCorrectLevel: "M",
            size: 150,
          });
        } else {
          this.error = true;
          this.errorMessage = data.message;
        }
      });
    },

    IEVersion() {
      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串

      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; // 判断是否IE<11浏览器

      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; // 判断是否IE的Edge浏览器

      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;

      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");

        reIE.test(userAgent);

        var fIEVersion = parseFloat(RegExp["$1"]);

        if (fIEVersion == 7) {
          return 7;
        } else if (fIEVersion == 8) {
          return 8;
        } else if (fIEVersion == 9) {
          return 9;
        } else if (fIEVersion == 10) {
          return 10;
        } else {
          return 6; // IE版本<=7
        }
      } else if (isEdge) {
        return "edge"; // edge
      } else if (isIE11) {
        return 11; // IE11
      } else {
        return -1; // 不是ie浏览器
      }
    },

    isWeixin() {
      // let ua = navigator.userAgent
      // return !!/MicroMessenger/i.test(ua) || !!/QQ/i.test(ua)
      var browser = navigator.userAgent.toLowerCase();
      if (browser.match(/MicroMessenger/i) == "micromessenger") {
        // 微信浏览器
        return true;
      } else if (
        browser.indexOf(" qq") != -1 &&
        browser.indexOf("mqqbrowser") != -1
      ) {
        // qq内置浏览器
        return true;
      } else if (
        browser.indexOf("mqqbrowser") != -1 &&
        browser.indexOf(" qq") == -1
      ) {
        // qq浏览器
        return false;
      } else {
        return false;
      }
    },

    /**
     * 下载文件
     * @param {} filesUrl
     */
    download (filesUrl) {
      var form = document.createElement('a')
      form.href = filesUrl
      // form.download = this.info.file_name
      console.log(this.info.file_name)
      document.body.appendChild(form)
      form.click()
      document.body.removeChild(form)
    },
    /**
     * 生成cnd签名
     */
    downFileApi() {
      let filesUrl = `https://cloud.hipcapi.com/${encodeURIComponent(this.info.cloudfile.file_key)}`
      this.download(filesUrl)
      // 鉴权下载
      // const data_opt = {
      //   path: this.info.cloudfile.file_key,
      // }
      // getCdnSignature(data_opt).then((res) => {
      //   if (res.code === 100) {
      //     // let filesUrl = `${res.data}&response-content-disposition=attachment`;
      //     let filesUrl = res.data
      //     this.download(filesUrl)
      //   }
      // });
    },
    // 预览文件
    previewFile() {
      var fileReg = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt)$/;
      var Extension = this.info.Extension;
      if (!fileReg.test(Extension)) {
        this.$message.error("此类型文件暂不支持在线预览");
        return;
      }
      const data_opt = {
        path: this.info.cloudfile.file_key,
      };
      getCdnSignature(data_opt).then((res) => {
        if (res.code === 100) {
          let filesUrl = res.data;
          const reg = /\.(ppt|pptx)$/;
          if (reg.test(Extension)) {
            filesUrl = `https://view.officeapps.live.com/op/view.aspx?src=${filesUrl}`;
          }
          this.goToPageWithParams("PreviewFile", { filesUrl, type: Extension });
        }
      });
    },
    // 带参数跳转到指定路由
    goToPageWithParams(routeName, params) {
      this.$router.push({ name: routeName, params: params });
    },
  },
  beforeDestroy() {
    // 组件销毁前移除 resize 事件监听器
    window.removeEventListener(
      "resize",
      this.debounce(this.checkDeviceType, 200)
    );
  },
};
</script>

<style scoped>
page {
  background: #fafcff;
}

.files-content {
  /*max-width: 400px;*/
}

.files-content /deep/ .el-dialog {
  border-radius: 10px;
}
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  /*display: none;*/
}
.ban-radio {
  font-size: 14px;
  margin: 5px 0;
}

.confirm-btn {
  width: 150px;
}

.contents {
  width: 100%;
  max-width: 400px;
  padding: 0 1rem;
  margin: 0 auto;
  transition: all 0.2s ease;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 0;
  z-index: 10;
  /* overflow: scroll; */
  -webkit-overflow-scrolling: touch;
}
.body {
  width: 100%;
  margin-top: 20px;
}
.-head {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.-head .head-left {
  display: flex;
  align-items: center;
}
.-avatar {
  width: 50px;
}
.-avatar .user-avatar {
  width: 100%;
  border-radius: 50px;
  overflow: hidden;
  min-width: 50px;
}
.-avatar .ic-pro {
  position: absolute;
  bottom: -2px;
  left: 11px;
  width: 30px;
  height: 15px;
}
.title {
  height: 20px;
  width: calc(100% - 40px);
  line-height: 20px;
  padding-left: 10px;
  float: left;
  margin-top: 2px;
  margin-bottom: 3px;
  font-size: 1rem;
  word-wrap: break-word;
}
._text-overflow {
  word-break: break-all;
  text-align: left;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.meta {
  height: 15px;
  width: calc(100% - 50px);
  line-height: 15px;
  padding-left: 10px;
  float: left;
  font-size: 12px;
  color: #848a95;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.report {
  margin-left: 12px;
  color: #3385ff;
  cursor: pointer;
}
.main-info {
  width: 100%;
  padding: 20px 20px;
  margin-bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  /* box-shadow: 0px 2px 10px 0px rgb(184 192 204 / 40%); */
  /* box-shadow: 0 0 20px rgb(0 0 0 / 10%); */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  min-height: 300px;
}
.qrcode {
  border-radius: unset !important;
  height: 30px !important;
  width: 30px !important;
}
.file-name {
  width: 100%;
  font-size: 1.25rem;
  line-height: 1.5;
  word-wrap: break-word;
}
.file-size {
  font-size: 14px;
  color: #848a95;
  margin-top: 10px;
  display: inline-block;
}
.file-mode-center {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.file-wallpaper {
  /* width: 50%; */
  border-radius: 4px;
  margin-bottom: 10px;
  margin-top: 50px;
}
.file-icon {
  width: 6.25rem;
  margin-top: 50px;
  margin-bottom: 10px;
}
.tips {
  font-size: 14px;
  text-align: center;
  color: #848a95;
  margin-top: 50px;
  margin-bottom: 20px;
}
.buttons {
  position: fixed;
  bottom: 0px;
  width: calc(100% - 0rem);
  z-index: 11;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: white;
}

.new-button {
  width: calc(100% - 4rem);
  height: 50px;
  line-height: 50px;
  background: #3385ff;
  color: #fff;
  text-align: center;
  margin: 30px;
  border-radius: 50px;
}

.computer-button {
  width: 40px;
  height: 40px;
  background-color: #409eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.computer-button:last-child {
  margin-left: 20px;
}

.computer-button .button-icon {
  width: 20px;
}

@media (min-width: 768px) {
  .contents {
    max-width: 1200px;
  }
  .main-info {
    min-height: 600px;
  }
  .file-wallpaper {
    margin-top: 70px;
    margin-bottom: 20px;
  }
  .tips {
    margin-top: 70px;
  }
  .file-icon {
    width: 150px;
    margin-top: 70px;
    margin-bottom: 20px;
  }
  .file-name {
    width: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/ShareFilesDetail2.vue